import axios from 'axios';

import { noop } from '@altirllc/shared/utils/functionalUtils';

import { LOCAL } from '@/constants';

import type { TLogRecord, TTrack } from './types';
import { detailsToString } from './utils';

const LOKI_SERVER = 'https://loki-push.hyperfuel.net/loki/api/v1';
const LOKI_APP = 'hf-admin-ui';

const lokiService = axios.create({
  baseURL: LOKI_SERVER,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Maybe batch?
const track: TTrack = ({ level, timeStamp, category, ...details }: TLogRecord) => {
  const body = {
    streams: [
      {
        stream: {
          app: LOKI_APP,
          environment: window.env.env,
          category,
          level,
        },
        values: [[String(timeStamp * 10e5), detailsToString(details)]],
      },
    ],
  };

  lokiService.post('push', body).catch((error) => {
    console.warn(`Pushing a log to Loki failed`, error);
  });
};

export const trackLoki = LOCAL ? noop : track;
